<template>
	<div class="fresh-news">
		<!-- 用户信息 -->
		<div class="userTop">
			<img :src="user_info.avatar" alt="" srcset="" class="head-img">
			<div>{{ user_info.name }}</div>
		</div>
		<!-- 功能操作 -->
		<div class="flex justify-between" style="width: 80%;margin: auto;">
			<div class="cont-item">
				<img src="/static/images/my/1.png" alt="" class="icon-img">
				<p class="text-style">待付款</p>
			</div>
			<div class="cont-item">
				<img src="/static/images/my/2.png" alt="" class="icon-img">
				<p class="text-style">待发货</p>
			</div>
			<div class="cont-item">
				<img src="/static/images/my/3.png" alt="" class="icon-img">
				<p class="text-style">待收货</p>
			</div>
		</div>
		<div class="flex justify-between" style="width: 50%;margin: 24px auto;">
			<div class="cont-item">
				<img src="/static/images/my/4.png" alt="" class="icon-img">
				<p class="text-style">待评价</p>
			</div>
			<div class="cont-item">
				<img src="/static/images/my/5.png" alt="" class="icon-img">
				<p class="text-style">退款/售后</p>
			</div>
		</div>
		<div class="flex justify-between" style="width: 50%;margin: 24px auto;">
			<div class="cont-item">
				<img src="/static/images/my/6.png" alt="" class="icon-img">
				<p class="text-style">宝贝收藏</p>
			</div>
			<div class="cont-item">
				<img src="/static/images/my/7.png" alt="" class="icon-img">
				<p class="text-style">我的足迹</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FreshNews',
		data() {
			return {
				user_info: {},//用户信息
			}
		},
		created() {
			let user_info = this.$cookies.get('user_info')
			this.user_info = JSON.parse(user_info)
			console.log(this.user_info);
		},
		methods: {
			mouseEnter: function (news) {
				news.enter = !news.enter;
				// news.leave = false;
			},
			// mouseLeave: function (news) {
			// 	news.enter = false;
			// 	news.leave = true;
			// },
		},
	};
</script>

<style scoped>
	.fresh-news {
		width: 320px;
		height: 100%;
		background-color: #F7F8FC;
		float: right;
		position: absolute;
		top: 0;
		right: 0;
		border-radius: 8px;
	}

	.userTop {
		color: #333;
		font-size: 18px;
		text-align: center;
		padding: 24px 0;
	}

	.head-img {
		width: 48px;
		height: 48px;
	}

	.icon-img {
		width: 26px;
		height: 26px;
	}

	.text-style {
		color: #666;
		font-size: 14px;
	}

	.cont-item {
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/FreshNews.vue